import {
  ProjectService,
  StudioService,
  UserService,
  TypeFactoryService,
  StudioFactory,
  I18nService,
  FileService
} from "@wms/services";
import {PreferenceService} from "@wms/services";

import {loadScripts, loadStyleSheet, loadStyleSheets, PROJECT_ID_PARAM_NAME} from "@wms/core";
import {environment} from "../../environments/environment";
import { runtimeEventManager } from "@wm/core";

const loadMobileFiles: Function = (projService: ProjectService) => {
  if (projService.isNativeMobileApplicationType()) {
    const buildNumber = environment.BUILD_NUMBER;
    const cdnBaseURL = environment.CDN_BASE_URL;
    const _url = cdnBaseURL ? cdnBaseURL : buildNumber ? buildNumber + '/' : '';
    let styleUrls;
    if(_url){
      styleUrls = [_url + 'wm-responsive.css', _url + 'wm-native-studio.css' ];
      if(!projService.isPrism())
        styleUrls.push(_url + 'wm-native-widgets.css');
    }
    else {
      styleUrls = ['wm-responsive.css', 'wm-native-studio.css'];
      if(!projService.isPrism())
        styleUrls.push('wm-native-widgets.css');
    }
    loadStyleSheets(styleUrls);
  }
}

const loadCustomIcons: Function = (projService: ProjectService, fileService: FileService) => {
  fileService.read('font.config.js').then(  (result: any) => {
    const projectID = projService.getProjectId();
    const cssPaths = [];
    const regex = /"csspath":\s*"([^"]+)"/g;
    let match;
    while ((match = regex.exec(result)) !== null) {
      cssPaths.push( '/studio/services/projects/' + projectID
        + '/resources/info/web/' + match[1]);
    }
    loadStyleSheets(cssPaths);
  }, () => console.log('file does not exist'));
}

export function InitData(studioService: StudioService, userService: UserService, projectService: ProjectService, preferencesService: PreferenceService,
                         typeFactory: TypeFactoryService, studioFactory: StudioFactory, i18nService: I18nService, fileService: FileService) {

  const dataInitializer = () => {
    runtimeEventManager.setService('environment', environment);
    return Promise.all([
      userService.fetch(),
      // loadScripts(['/assets/agentic-chat/autocode-preview-agentic-chat.umd.js']),
      projectService.loadDetailsAndPreferences().then(() => {
        loadMobileFiles(projectService);
        if(projectService.getDetails().type === 'APPLICATION') {
          loadCustomIcons(projectService, fileService);
        }
        studioFactory.init();
      }),
      projectService.loadEdnDetails(),
      i18nService.getMessages(),
    ])
  };

  return () => {
    // get project id from query param projectId in url
    //let queryParams = new URLSearchParams(window.location.search);
    //studioService.setEditInWM(queryParams.get('edit_in_wm'));
    window.history.pushState({}, '', window.location.pathname + window.location.search.replace('&edit_in_wm=true', ''));
    let projectId = window.location.search.split(PROJECT_ID_PARAM_NAME + '=')[1];
    if (projectId) {
      projectId = projectId.split('&')[0];
      projectService.setProjectId(projectId);
    } else {
      // if project-id not found, redirect to old project listing page
      window.location.href = '/projects';
    }

    return new Promise((resolve, reject) => {
      dataInitializer()
        .then((allData) => {
        resolve(allData);
      }).then(() => {
        runtimeEventManager.emit('on-studio-services-initialized', projectService.getDetails());
      });
    });
  }
}
